/**
 * Logic for multicheckbox-widgets – extendable lists of checkboxes with "more"/"less" button
 */

import $ from 'jquery';
import App from 'libs/app';

$.widget('tud.multicheck', {
    options: {
        size: 4,
        threshold: 1,
    },
    _create() {
        this.extendOptions();
        this.isVisible = true;
        this.$innerBox = this.element.find('.multicheck-box');

        this.update();

        this._on(this.element, {
            'click .multicheck-toggler': this.toggle,
        });
    },

    update() {
        const $items = this.getAdditionalItems();
        const action = $items.length
            ? 'removeClass'
            : 'addClass';
        this.element[action]('hide-button');
        if ($items.length) {
            this.hide($items, true);
        }
    },

    getAdditionalItems() {
        const items = this.element.find('.checkboxes-std');
        const { length } = items;
        const o = this.options;

        if (length > (o.size + o.threshold)) {
            return items.slice(o.size, length);
        }
        return $([]);
    },

    toggle() {
        if (this.isVisible) {
            this.hide();
        } else {
            this.show();
        }
    },

    show() {
        if (!this.isVisible) {
            this.animate({
                calcAction: 'show',
                beforeAnimate: 'hide',
                anim: 'fadeIn',
            });
            this.element.removeClass('closed');
            this.isVisible = true;
            this.element.find('.multicheck-toggler .more').hide();
            this.element.find('.multicheck-toggler .less').show();
        }
    },
    hide($items, noAnimate) {
        if (this.isVisible) {
            if (!$items) {
                $items = this.getAdditionalItems();
            }
            if (noAnimate) {
                $items.hide();
            } else {
                this.animate({
                    calcAction: 'hide',
                    beforeAnimate: 'show',
                    anim: 'fadeOut',
                });
            }

            this.element.addClass('closed');
            this.isVisible = false;
            this.element.find('.multicheck-toggler .more').show();
            this.element.find('.multicheck-toggler .less').hide();
        }
    },
    animate(desc) {
        const endHeight = this.$innerBox.height();
        const initialHeight = this.$innerBox.height();
        const $items = this.getAdditionalItems()[desc.calcAction]();

        this.$innerBox.css({
            overflow: 'hidden',
            height: initialHeight,
        });

        $items[desc.beforeAnimate]()[desc.anim]();
        this.$innerBox
            .animate({
                height: endHeight,
            }, {
                complete() {
                    $(this).css({ overflow: '', height: '' });
                },
            });
    },

    extendOptions() {
        const data = this.element.data();
        const o = this.options;
        $.each(this.options, (name, value) => {
            if (name in data) {
                o[name] = data[name];
            }
        });
    },
});

App.registerUiComponent('multicheck', () => {
    $('.multicheck').multicheck();
});
